import React from 'react';

const ContactInfoSection = ({ config, setConfig }) => (
  <div className="bg-white rounded-lg shadow-lg p-6 mb-6" data-testid="contact-info-section">
    <h2 className="text-xl font-bold mb-4">Contact Information</h2>
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
        <input
          type="email"
          data-testid="settings-email-input"
          value={config.email}
          onChange={(e) => setConfig({ ...config, email: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          WhatsApp Number (with country code)
        </label>
        <input
          type="text"
          data-testid="settings-whatsapp-input"
          value={config.whatsapp}
          onChange={(e) => setConfig({ ...config, whatsapp: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
          placeholder="447577300027"
          required
        />
      </div>
    </div>
  </div>
);

export default ContactInfoSection;
